module.exports = __webpack_public_path__ + "img/sc-logo.c12b5f9e.png";